import { render, staticRenderFns } from "./modalDiagnosticoEgreso.vue?vue&type=template&id=4fb81ab1"
import script from "./modalDiagnosticoEgreso.vue?vue&type=script&lang=js"
export * from "./modalDiagnosticoEgreso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports